import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MessengerHeader = _resolveComponent("MessengerHeader")!
  const _component_MessengerConnectionStatus = _resolveComponent("MessengerConnectionStatus")!
  const _component_MessengerMessageList = _resolveComponent("MessengerMessageList")!
  const _component_MessengerEditor = _resolveComponent("MessengerEditor")!
  const _component_MessengerConversationEnded = _resolveComponent("MessengerConversationEnded")!
  const _component_MessengerStartChatForm = _resolveComponent("MessengerStartChatForm")!
  const _component_MessengerChannelPicker = _resolveComponent("MessengerChannelPicker")!
  const _component_Dropzone = _resolveComponent("Dropzone")!
  const _component_DialogWrapper = _resolveComponent("DialogWrapper")!
  const _component_PopTransition = _resolveComponent("PopTransition")!

  return (_openBlock(), _createBlock(_component_PopTransition, {
    "show-content": _ctx.isOpen,
    "content-style": !_ctx.isMobile ? 'height: calc(100% - 125px);' : '',
    "content-classes": [
      _ctx.isMobile
        ? 'bottom-0 w-full h-full'
        : 'shadow-xl right-[10px] ml-[10px] rounded-lg max-h-[700px] w-[375px] bottom-[100px]',
      'fixed min-h-[400px]',
    ]
  }, {
    default: _withCtx(() => [
      _createVNode(_component_Dropzone, {
        enabled: true,
        onActivated: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dropZoneTriggered = true)),
        onDeactivated: _cache[2] || (_cache[2] = ($event: any) => (_ctx.dropZoneTriggered = false)),
        onFilesDropped: _ctx.onFilesDropped,
        class: _normalizeClass(['h-full flex flex-col justify-between', _ctx.dropzoneClass])
      }, {
        default: _withCtx(() => [
          _createVNode(_component_MessengerHeader, {
            onMinimize: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('minimize')))
          }),
          (!_ctx.isPreviewMode)
            ? (_openBlock(), _createBlock(_component_MessengerConnectionStatus, { key: 0 }))
            : _createCommentVNode("", true),
          (_ctx.isConversationStarted)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createVNode(_component_MessengerMessageList, {
                  ref: "messageList",
                  class: _normalizeClass(["h-full flex-grow overflow-auto pt-6 scrollview", [_ctx.backgroundClass, 'transition-colors']])
                }, null, 8, ["class"]),
                (_ctx.showEditor)
                  ? (_openBlock(), _createBlock(_component_MessengerEditor, {
                      key: 0,
                      class: _normalizeClass([_ctx.backgroundClass, 'transition-colors'])
                    }, null, 8, ["class"]))
                  : (_openBlock(), _createBlock(_component_MessengerConversationEnded, {
                      key: 1,
                      class: _normalizeClass([_ctx.backgroundClass, 'transition-colors'])
                    }, null, 8, ["class"]))
              ], 64))
            : (_openBlock(), _createElementBlock("div", {
                key: 2,
                class: _normalizeClass(["flex-grow flex flex-col content-center place-content-center items-center overflow-auto", [_ctx.backgroundClass, 'transition-colors']])
              }, [
                (_ctx.hasSelectedChannel)
                  ? (_openBlock(), _createBlock(_component_MessengerStartChatForm, { key: 0 }))
                  : (_openBlock(), _createBlock(_component_MessengerChannelPicker, { key: 1 }))
              ], 2))
        ]),
        _: 1
      }, 8, ["onFilesDropped", "class"]),
      _createVNode(_component_DialogWrapper)
    ]),
    _: 1
  }, 8, ["show-content", "content-style", "content-classes"]))
}